import { CheckoutProbabilityPredictionRange } from "@redotech/redo-model/conversion/checkout-probability";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getCheckoutProbabilityMeasurementMetrics = {
  name: "getCheckoutProbabilityMeasurementMetrics" as const,
  input: z.null(),
  output: z.object({
    checkoutProbabilityMeasurementMetrics: z.record(
      createEnum(CheckoutProbabilityPredictionRange),
      z.object({
        checkoutCompletionsRate: z.number(),
        totalCompletedCheckouts: z.number(),
        totalSessions: z.number(),
      }),
    ),
  }),
};
